import type { AppIcon } from '../ui/FaIcons';
import {
  FaCalendar,
  FaCircleInfo,
  FaComments,
  FaFileInvoice,
  FaFolderOpen,
  FaListCheck,
  FaUserGroup,
} from '../ui/FaIcons';

export const DOSSIER_DETAIL_TABS: {
  key: string;
  label: string;
  to: string;
  icon: AppIcon;
  countKey?: 'parties' | 'documents' | 'taches';
}[] = [
  { key: 'resume',      label: 'Aperçu',         to: 'resume',      icon: FaCircleInfo },
  { key: 'parties',     label: 'Parties',        to: 'parties',     icon: FaUserGroup,   countKey: 'parties' },
  { key: 'documents',   label: 'Documents',      to: 'documents',   icon: FaFolderOpen,  countKey: 'documents' },
  { key: 'taches',      label: 'Tâches',         to: 'taches',      icon: FaListCheck,   countKey: 'taches' },
  { key: 'agenda',      label: 'Agenda',         to: 'agenda',      icon: FaCalendar },
  { key: 'discussions', label: 'Discussions',    to: 'discussions', icon: FaComments },
  { key: 'facturation', label: 'Facturation',    to: 'facturation', icon: FaFileInvoice },
];
